var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('field-input',{attrs:{"label":_vm.priceLabel},model:{value:(_vm.price),callback:function ($$v) {_vm.price=$$v},expression:"price"}})}
var staticRenderFns = []

export { render, staticRenderFns }